/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

"use client";

import { CosmosComponentContextProps } from "@cosmos/components";
import router from "next/router";
import NextLink from "next/link";
import { CustomImage } from "@cosmos/next-common";
import { Loading } from "@site/components/loading";
import { locales } from "@i18n/config";
import Lottie from "lottie-react";

export const componentContext: CosmosComponentContextProps = {
	hygraphMediaDomain: process.env.NEXT_PUBLIC_HYGRAPH_MEDIA_DOMAIN,
	feedBrand: "unreal-engine",
	feedRootPath: "/feed",
	Image: CustomImage,
	Link: NextLink,
	LoadingComponent: Loading,
	Lottie,
	router,
	enableAuth: true,
	locales,
};
